import { Home } from "./pages/Home";
import { Experience } from "./pages/Experience";
import { Portfolio } from "./pages/Portfolio";

import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <Routes>
      <Route element={<Home />} path="/" />
      <Route element={<Portfolio />} path="/portfolio" />
      <Route element={<Experience />} path="/experience" />
    </Routes>
  );
}

export default App;
